import React from 'react';
import LogPagination from './LogPagination';

/**
 * Generic table renderer.
 * Props:
 *   columns   – [{ key, label, render? }]
 *   rows      – array of objects
 *   loading   – bool
 *   error     – string | null
 *   page / totalPages / totalItems / pageSize / onPageChange
 *   title     – string
 *   onExport  – () => void (optional)
 *   onRefresh – () => void
 */
const LogTable = ({
  columns, rows = [], loading, error,
  page, totalPages, totalItems, pageSize, onPageChange,
  title, onExport, onRefresh,
}) => {
  const formatCell = (row, col) => {
    if (col.render) return col.render(row[col.key], row);
    const v = row[col.key];
    if (v === null || v === undefined) return <span style={{ color: '#d1d5db' }}>—</span>;
    const s = String(v);
    return s.length > 80 ? (
      <span title={s} className="al-truncate">{s.slice(0, 80)}…</span>
    ) : s;
  };

  return (
    <div className="al-table-wrap">
      {/* Header */}
      <div className="al-table-header">
        <span className="al-table-title">{title}</span>
        <div className="al-table-actions">
          {onExport && (
            <button className="al-icon-btn" onClick={onExport} title="Export CSV">
              ⬇ Export
            </button>
          )}
          <button className="al-icon-btn" onClick={onRefresh} title="Refresh">
            ↻ Refresh
          </button>
        </div>
      </div>

      {/* Body */}
      <div className="al-table-scroll">
        {loading ? (
          <div className="al-loading">
            <div className="al-spinner" />
            <span>Loading logs…</span>
          </div>
        ) : error ? (
          <div className="al-empty" style={{ color: '#EF4444' }}>
            <span style={{ fontSize: 28 }}>⚠</span>
            <span>{error}</span>
          </div>
        ) : rows.length === 0 ? (
          <div className="al-empty">
            <span style={{ fontSize: 32 }}>📋</span>
            <span>No records found</span>
          </div>
        ) : (
          <table className="al-table">
            <thead>
              <tr>
                {columns.map(c => (
                  <th key={c.key}>{c.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.id || i}>
                  {columns.map(c => (
                    <td key={c.key}>{formatCell(row, c)}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      {!loading && !error && rows.length > 0 && (
        <LogPagination
          page={page}
          totalPages={totalPages}
          totalItems={totalItems}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default LogTable;
